import { CheckCircle2, Info } from 'lucide-react';
import CustomInput from '../../../../../components/forms/CustomInput';

const CheckoutGstSection = ({
  gstinNumber,
  handleGstNumberChange,
  saveGstDetailsToProfile,
  gstVerified,
  gstLegalName,
  setGstLegalName,
  gstAddress,
  setGstAddress,
  isSameState,
  billingState,
  cgstAmount,
  sgstAmount,
  totalGstAmount,
  formatCurrency
}) => {
  return (
    <section className="rounded-2xl sm:rounded-3xl border border-slate-200 bg-white p-4 sm:p-6 shadow-sm space-y-3.5 sm:space-y-4">
      <div>
        <span className="text-[11px] sm:text-xs font-bold uppercase tracking-wider text-[#067978]">Step 4</span>
        <h2 className="text-base sm:text-lg font-semibold text-slate-900 mt-0.5">GST number</h2>
        <p className="text-xs text-slate-500 mt-0.5 font-normal">Optional. Add it to claim input tax credit on this subscription.</p>
      </div>

      <div className="space-y-3 sm:space-y-3.5 pt-1">
        <div>
          <CustomInput
            label="GSTIN Number (15 Characters)"
            type="text"
            maxLength={15}
            value={gstinNumber}
            onChange={(e) => handleGstNumberChange(e.target.value)}
            onBlur={saveGstDetailsToProfile}
            placeholder="27AABCO1234A1Z5"
            mono={true}
          />
          {gstVerified && (
            <div className="flex items-center gap-1.5 text-xs text-[#067978] font-semibold mt-1.5">
              <CheckCircle2 size={14} className="text-[#067978]" />
              <span>Verified GSTIN Format</span>
            </div>
          )}
        </div>

        <div>
          <CustomInput
            label="Registered Name on GST"
            type="text"
            value={gstLegalName}
            onChange={(e) => setGstLegalName(e.target.value)}
            onBlur={saveGstDetailsToProfile}
            placeholder="e.g. Orbitra Technologies LLP"
          />
        </div>

        <div className="space-y-1.5">
          <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">Registered Business Address</label>
          <textarea
            rows={2}
            value={gstAddress}
            onChange={(e) => setGstAddress(e.target.value)}
            onBlur={saveGstDetailsToProfile}
            placeholder="Address as registered on GST certificate"
            className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-xs sm:text-sm font-normal text-slate-700 transition-all outline-none focus:border-primary focus:ring-1 focus:ring-primary resize-none shadow-sm"
          />
        </div>

        {/* ITC Claim Notice */}
        {gstinNumber.trim().length > 0 && (
          <div className="p-3 sm:p-3.5 rounded-xl bg-teal-50/60 border border-teal-100 text-xs text-slate-700 leading-relaxed font-normal flex items-start gap-2.5">
            <Info size={15} className="shrink-0 text-[#067978] mt-0.5" />
            <div>
              {isSameState ? (
                <span>
                  Because your billing state matches GSTIN state (<b>{billingState}</b>), tax shows as <b>CGST 9% ({formatCurrency(cgstAmount)}) + SGST 9% ({formatCurrency(sgstAmount)})</b>. This <b>{formatCurrency(totalGstAmount)}</b> GST is claimable as input tax credit on your filings.
                </span>
              ) : (
                <span>
                  Inter-state billing applies: tax shows as <b>IGST 18% ({formatCurrency(totalGstAmount)})</b>. Claimable as input tax credit on filings.
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CheckoutGstSection;
